/*
* Project: LegalPlace assistant
* File: src/redux/reducers/input_context.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/


import { IC_SET_OPTION, IC_SET_VARIABLE } from '../actions/input_context';


export function inputContext(state = { variable: '', option: '' }, action) {
  switch (action.type) {
    case IC_SET_OPTION:
      return { ...state, option: action.optionid };
    case IC_SET_VARIABLE:
      return { ...state, variable: action.varid };
    default:
      return state;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/input_context.js